import type { Probe } from '../../services/data';

interface ProbeTabsProps {
  probes: Probe[];
  selectedIndex: number;
  onChange: (index: number) => void;
}

export default function ProbeTabs({ probes, selectedIndex, onChange }: ProbeTabsProps) {
  if (probes.length <= 1) return null;

  return (
    <div className="flex overflow-x-auto border-b border-gray-200 mb-0">
      {probes.map((probe, i) => (
        <button
          key={probe.id}
          onClick={() => onChange(i)}
          className={`flex flex-col items-start px-4 py-2 text-sm whitespace-nowrap border-b-2 transition-colors ${
            i === selectedIndex
              ? 'border-blue-600 text-blue-600 bg-white'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}
        >
          <span className="text-xs text-gray-400 font-mono">
            P{String(probe.position ?? i + 1).padStart(2, '0')}
          </span>
          <span className="font-medium">{probe.name}</span>
        </button>
      ))}
    </div>
  );
}
